import { dashboardApiURL } from "API/urls/dashboard.api";
import { axiosInstance } from "configs/axios";

export const taskCompletionStatusApi = async () => {
  try {
    const response = await axiosInstance.get(
      dashboardApiURL.taskCompletionStatus
    );
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response?.data || "No data",
      status: error?.response?.request?.status || "No status",
    };
  }
};
